<template>
  <div class="drivers container-fluid r-aside">
    <loading :active.sync="isLoading"
             :can-cancel="true">
    </loading>

    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h3 class="text-themecolor">{{ title }}</h3>
      </div>
      <div class="col-md-7 align-self-center">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
          <li class="breadcrumb-item active">{{ title }}</li>
        </ol>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div v-if="getUser()['is_admin'] || getUser()['is_superuser']" class="col-md-3 col-lg-3 p-0">
              <div class="m-3">
                <label class="search-label">Month</label>
                <select type="text" placeholder="Month"
                        class="form-control ddown" id="month-filter" v-model="selected_month" v-on:change="getReports()">
                  <option v-for="month in months" v-bind:value="month.month">
                    {{ month.name + ' ' + month.year }}
                  </option>
                </select>
              </div>
            </div>

            <!--<div class="report-container">-->
              <!--<div>-->
                <!--<h4>Weekly GA Report for period: {{ weeks[selected_ga_week]['last_monday'] }} - {{ weeks[selected_ga_week]['last_sunday'] }} </h4>-->
              <!--</div>-->
              <!--<select @change="getVeridaWeeklyReport('GEORGIA')" v-model="selected_ga_week" class="form-control ddown" style="width: 200px; margin-right: 15px;">-->
                <!--<option v-for="week in weeks" v-bind:value="week.week">-->
                  <!--{{ week.last_monday + ' - ' + week.last_sunday }}-->
                <!--</option>-->
              <!--</select>-->
              <!--<button @click="download('weekly', 'GEORGIA')" class="btn btn-info waves-effect waves-light m-b-10" style="cursor: pointer;">Export</button>-->
              <!--<button @click="showEmailConfirmModal = true; emailType = 'Weekly'; emailMarket = 'GEORGIA'" class="btn btn-info waves-effect waves-light m-b-10" style="cursor: pointer;">Email</button>-->
              <!--<div class="" style="max-height: 300px; overflow-y: auto;">-->
                <!--<form v-on:submit.prevent>-->
                  <!--<table class="table table-sm table-hover" data-sort-name="Date">-->
                    <!--<thead>-->
                    <!--<tr>-->
                      <!--<th class="result-label" v-for="column in data.weeklyColumns">-->
                        <!--<div>-->
                          <!--{{column}}-->
                          <!--<div class="arrow-down" v-bind:id="column" style="visibility: hidden; margin-left: 5px;"></div>-->
                        <!--</div>-->
                      <!--</th>-->
                    <!--</tr>-->
                    <!--</thead>-->
                    <!--<tbody class="col-12">-->
                    <!--<tr class="ride-item text-xs-center" v-for="ride in data.weeklyGArides" >-->
                      <!--<td class="result-item" v-for="(item, index) in ride">-->
                        <!--<div v-if="index < 2">-->
                          <!--<router-link :to="'/rides/' + ride[0] + '/'">-->
                            <!--&lt;!&ndash;<router-link :to="{name: 'Rides', params: {id_ride: ride.id_ride}}">&ndash;&gt;-->
                            <!--<div v-if="item != null" style="margin-top: inherit !important;">{{ item }}</div>-->
                            <!--<div v-if="item == null" style="margin-top: inherit !important;">None</div>-->
                          <!--</router-link>-->
                        <!--</div>-->
                        <!--<div v-else>-->
                          <!--{{ item }}-->
                        <!--</div>-->
                      <!--</td>-->
                    <!--</tr>-->
                    <!--</tbody>-->
                  <!--</table>-->
                <!--</form>-->
              <!--</div>-->
              <!--<div style="background-color: rgba(0, 0, 0, 0.05); float: left; width: 100%;">-->
                <!--<div style="margin: 1rem 1rem; float: left;">-->
                  <!--<span v-if="totalWeeklyGARows > 0">Showing 1 to {{ totalWeeklyGARows }} of {{ totalWeeklyGARows }} entries</span>-->
                  <!--<span v-else>Showing 0 entries</span>-->
                <!--</div>-->
              <!--</div>-->
            <!--</div>-->
            <!--<div class="report-container">-->
              <!--<div>-->
                <!--<h4>Verida GA Rides Itemized Report</h4>-->
              <!--</div>-->
              <!--<button @click="download('itemized', 'GEORGIA', 'verida')" class="btn btn-info waves-effect waves-light m-b-10" style="cursor: pointer;">Export</button>-->
              <!--<button @click="showEmailConfirmModal = true; emailType = 'Itemized'; emailMarket = 'GEORGIA'; emailProvider = 'verida'" class="btn btn-info waves-effect waves-light m-b-10" style="cursor: pointer;">Email</button>-->
              <!--<div class="" style="max-height: 300px; overflow-y: auto;">-->
                <!--<form v-on:submit.prevent>-->
                  <!--<table class="table table-sm table-hover" data-sort-name="Date">-->
                    <!--<thead>-->
                    <!--<tr>-->
                      <!--<th class="result-label" v-for="column in data.veridaItemizedColumns">-->
                        <!--<div>-->
                          <!--{{column}}-->
                          <!--<div class="arrow-down" v-bind:id="column" style="visibility: hidden; margin-left: 5px;"></div>-->
                        <!--</div>-->
                      <!--</th>-->
                    <!--</tr>-->
                    <!--</thead>-->
                    <!--<tbody class="col-12">-->
                    <!--<tr class="ride-item text-xs-center" v-for="itemizedGAride in data.veridaGAitemized" >-->
                      <!--<td class="result-item" v-for="item in itemizedGAride">-->
                        <!--{{ item }}-->
                      <!--</td>-->
                    <!--</tr>-->
                    <!--</tbody>-->
                  <!--</table>-->
                <!--</form>-->
              <!--</div>-->
              <!--<div style="background-color: rgba(0, 0, 0, 0.05); float: left; width: 100%;">-->
                <!--<div style="margin: 1rem 1rem; float: left;">-->
                  <!--<span v-if="totalVeridaItemizedGArows > 0">Showing {{ perPage * (veridaItemizedGAcurrentPage-1) + 1 }} to {{ perPage * veridaItemizedGAcurrentPage > totalVeridaItemizedGArows ? totalVeridaItemizedGArows : perPage * veridaItemizedGAcurrentPage }} of {{ totalVeridaItemizedGArows }} entries</span>-->
                  <!--&lt;!&ndash;<span v-if="totalVeridaItemizedGArows > 0">Showing {{ perPage * (veridaItemizedGAcurrentPage-1) + 1 }} to {{ totalVeridaItemizedGArows }} of {{ totalVeridaItemizedGArows }} entries</span>&ndash;&gt;-->
                  <!--<span v-else>Showing 0 entries</span>-->
                <!--</div>-->
                <!--<div style="margin: 0 1rem; float: right;">-->
                  <!--<b-pagination style="margin: .5rem 0;" align="center" :total-rows=totalVeridaItemizedGArows v-model="veridaItemizedGAcurrentPage" :per-page=perPage :limit=limit @change="changeVeridaItemizedGAPage">-->
                  <!--</b-pagination>-->
                <!--</div>-->
              <!--</div>-->
            <!--</div>-->
            <div v-if="getUser()['is_admin'] || getUser()['is_superuser']" class="report-container">
              <div>
                <h4>Verida GA Transaction Itemized Report</h4>
              </div>
              <!--<button @click="download('transaction', 'GEORGIA', 'verida')" class="btn btn-info waves-effect waves-light m-b-10" style="cursor: pointer;">Export</button>-->
              <button @click="showEmailConfirmModal = true; emailType = 'transaction'; emailMarket = 'GEORGIA'; emailProvider = 'verida'" class="btn btn-info waves-effect waves-light m-b-10" style="cursor: pointer;">Email</button>
              <div class="" style="max-height: 300px; overflow-y: auto;">
                <form v-on:submit.prevent>
                  <table class="table table-sm table-hover" data-sort-name="Date">
                    <thead>
                    <tr>
                      <th class="result-label" v-for="column in data.transactionItemizedColumns">
                        <div>
                          {{column}}
                          <div class="arrow-down" v-bind:id="column" style="visibility: hidden; margin-left: 5px;"></div>
                        </div>
                      </th>
                    </tr>
                    </thead>
                    <tbody class="col-12">
                    <tr class="ride-item text-xs-center" v-for="itemizedGAride in data.veridaGATransaction" >
                      <td class="result-item" v-for="item in itemizedGAride">
                        {{ item }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </form>
              </div>
              <div style="background-color: rgba(0, 0, 0, 0.05); float: left; width: 100%;">
                <div style="margin: 1rem 1rem; float: left;">
                  <span v-if="totalVeridaGATransactionRows > 0">Showing {{ perPage * (veridaTransactionGAcurrentPage-1) + 1 }} to {{ perPage * veridaTransactionGAcurrentPage > totalVeridaGATransactionRows ? totalVeridaGATransactionRows : perPage * veridaTransactionGAcurrentPage }} of {{ totalVeridaGATransactionRows }} entries</span>
                  <!--<span v-if="totalVeridaGATransactionRows > 0">Showing {{ perPage * (veridaTransactionGAcurrentPage-1) + 1 }} to {{ totalVeridaGATransactionRows }} of {{ totalVeridaGATransactionRows }} entries</span>-->
                  <span v-else>Showing 0 entries</span>
                </div>
                <div style="margin: 0 1rem; float: right;">
                  <b-pagination style="margin: .5rem 0;" align="center" :total-rows=totalVeridaGATransactionRows v-model="veridaTransactionGAcurrentPage" :per-page=perPage :limit=limit @change="changeVeridaTransactionGAPage">
                  </b-pagination>
                </div>
              </div>
            </div>

            <!--<div style="height: 100px"></div>-->
            <!--<div class="report-container">-->
              <!--<div>-->
                <!--<h4>Weekly TN Report for period: {{ weeks[selected_tn_week]['last_monday'] }} - {{ weeks[selected_tn_week]['last_sunday'] }}</h4>-->
              <!--</div>-->
              <!--<select @change="getVeridaWeeklyReport('TENNESSEE')" v-model="selected_tn_week" class="form-control ddown" style="width: 200px; margin-right: 15px;">-->
                <!--<option v-for="week in weeks" v-bind:value="week.week">-->
                  <!--{{ week.last_monday + ' - ' + week.last_sunday }}-->
                <!--</option>-->
              <!--</select>-->
              <!--<button @click="download('weekly', 'TENNESSEE')" class="btn btn-info waves-effect waves-light m-b-10" style="cursor: pointer;">Export</button>-->
              <!--<button @click="showEmailConfirmModal = true; emailType = 'Weekly'; emailMarket = 'TENNESSEE'" class="btn btn-info waves-effect waves-light m-b-10" style="cursor: pointer;">Email</button>-->
              <!--<div class="" style="max-height: 300px; overflow-y: auto;">-->
                <!--<form v-on:submit.prevent>-->
                  <!--<table class="table table-sm table-hover" data-sort-name="Date">-->
                    <!--<thead>-->
                    <!--<tr>-->
                      <!--<th class="result-label" v-for="column in data.weeklyColumns">-->
                        <!--<div>-->
                          <!--{{column}}-->
                          <!--<div class="arrow-down" v-bind:id="column" style="visibility: hidden; margin-left: 5px;"></div>-->
                        <!--</div>-->
                      <!--</th>-->
                    <!--</tr>-->
                    <!--</thead>-->
                    <!--<tbody class="col-12">-->
                    <!--<tr class="ride-item text-xs-center" v-for="weeklyTNride in data.weeklyTNrides" >-->
                      <!--<td class="result-item" v-for="(item, index) in weeklyTNride">-->
                        <!--<div v-if="index < 2">-->
                          <!--<router-link :to="'/rides/' + weeklyTNride[0] + '/'">-->
                            <!--&lt;!&ndash;<router-link :to="{name: 'Rides', params: {id_ride: ride.id_ride}}">&ndash;&gt;-->
                            <!--<div v-if="item != null" style="margin-top: inherit !important;">{{ item }}</div>-->
                            <!--<div v-if="item == null" style="margin-top: inherit !important;">None</div>-->
                          <!--</router-link>-->
                        <!--</div>-->
                        <!--<div v-else>-->
                          <!--{{ item }}-->
                        <!--</div>-->
                      <!--</td>-->
                    <!--</tr>-->
                    <!--</tbody>-->
                  <!--</table>-->
                <!--</form>-->
              <!--</div>-->
              <!--<div style="background-color: rgba(0, 0, 0, 0.05); float: left; width: 100%;">-->
                <!--<div style="margin: 1rem 1rem; float: left;">-->
                  <!--<span v-if="totalWeeklyTNRows > 0">Showing 1 to {{ totalWeeklyTNRows }} of {{ totalWeeklyTNRows }} entries</span>-->
                  <!--<span v-else>Showing 0 entries</span>-->
                <!--</div>-->
              <!--</div>-->
            <!--</div>-->
            <!--<div class="report-container">-->
              <!--<div>-->
                <!--<h4>Verida TN Rides Itemized Report</h4>-->
              <!--</div>-->
              <!--<button @click="download('itemized', 'TENNESSEE', 'verida')" class="btn btn-info waves-effect waves-light m-b-10" style="cursor: pointer;">Export</button>-->
              <!--<button @click="showEmailConfirmModal = true; emailType = 'Itemized'; emailMarket = 'TENNESSEE'; emailProvider = 'verida'" class="btn btn-info waves-effect waves-light m-b-10" style="cursor: pointer;">Email</button>-->
              <!--<div class="" style="max-height: 300px; overflow-y: auto;">-->
                <!--<form v-on:submit.prevent>-->
                  <!--<table class="table table-sm table-hover" data-sort-name="Date">-->
                    <!--<thead>-->
                    <!--<tr>-->
                      <!--<th class="result-label" v-for="column in data.veridaItemizedColumns">-->
                        <!--<div>-->
                          <!--{{column}}-->
                          <!--<div class="arrow-down" v-bind:id="column" style="visibility: hidden; margin-left: 5px;"></div>-->
                        <!--</div>-->
                      <!--</th>-->
                    <!--</tr>-->
                    <!--</thead>-->
                    <!--<tbody class="col-12">-->
                    <!--<tr class="ride-item text-xs-center" v-for="itemizedTNride in data.veridaTNitemized" >-->
                      <!--<td class="result-item" v-for="item in itemizedTNride">-->
                        <!--{{ item }}-->
                      <!--</td>-->
                    <!--</tr>-->
                    <!--</tbody>-->
                  <!--</table>-->
                <!--</form>-->
              <!--</div>-->
              <!--<div style="background-color: rgba(0, 0, 0, 0.05); float: left; width: 100%;">-->
                <!--<div style="margin: 1rem 1rem; float: left;">-->
                  <!--<span v-if="totalVeridaItemizedTNrows > 0">Showing {{ perPage * (veridaItemizedTNcurrentPage-1) + 1 }} to {{ perPage * veridaItemizedTNcurrentPage > totalVeridaItemizedTNrows ? totalVeridaItemizedTNrows : perPage * veridaItemizedTNcurrentPage }} of {{ totalVeridaItemizedTNrows }} entries</span>-->
                  <!--&lt;!&ndash;<span v-if="totalVeridaItemizedTNrows > 0">Showing {{ perPage * (veridaItemizedTNcurrentPage-1) + 1 }} to {{ totalVeridaItemizedTNrows }} of {{ totalVeridaItemizedTNrows }} entries</span>&ndash;&gt;-->
                  <!--<span v-else>Showing 0 entries</span>-->
                <!--</div>-->
                <!--<div style="margin: 0 1rem; float: right;">-->
                  <!--<b-pagination style="margin: .5rem 0;" align="center" :total-rows=totalVeridaItemizedTNrows v-model="veridaItemizedTNcurrentPage" :per-page=perPage :limit=limit @change="changeVeridaItemizedTNPage">-->
                  <!--</b-pagination>-->
                <!--</div>-->
              <!--</div>-->
            <!--</div>-->
            <div v-if="getUser()['is_admin'] || getUser()['is_superuser']" class="report-container">
              <div>
                <h4>Verida TN/VA Transaction Itemized Report</h4>
              </div>
              <!--<button @click="download('transaction', 'TENNESSEE', 'verida')" class="btn btn-info waves-effect waves-light m-b-10" style="cursor: pointer;">Export</button>-->
              <button @click="showEmailConfirmModal = true; emailType = 'transaction'; emailMarket = 'TENNESSEE'; emailProvider = 'verida'" class="btn btn-info waves-effect waves-light m-b-10" style="cursor: pointer;">Email</button>
              <div class="" style="max-height: 300px; overflow-y: auto;">
                <form v-on:submit.prevent>
                  <table class="table table-sm table-hover" data-sort-name="Date">
                    <thead>
                    <tr>
                      <th class="result-label" v-for="column in data.transactionItemizedColumns">
                        <div>
                          {{column}}
                          <div class="arrow-down" v-bind:id="column" style="visibility: hidden; margin-left: 5px;"></div>
                        </div>
                      </th>
                    </tr>
                    </thead>
                    <tbody class="col-12">
                    <tr class="ride-item text-xs-center" v-for="transactionTNride in data.veridaTNTransaction" >
                      <td class="result-item" v-for="item in transactionTNride">
                        {{ item }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </form>
              </div>
              <div style="background-color: rgba(0, 0, 0, 0.05); float: left; width: 100%;">
                <div style="margin: 1rem 1rem; float: left;">
                  <span v-if="totalVeridaTNTransactionRows > 0">Showing {{ perPage * (veridaTransactionTNcurrentPage-1) + 1 }} to {{ perPage * veridaTransactionTNcurrentPage > totalVeridaTNTransactionRows ? totalVeridaTNTransactionRows : perPage * veridaTransactionTNcurrentPage }} of {{ totalVeridaTNTransactionRows }} entries</span>
                  <!--<span v-if="totalVeridaTNTransactionRows > 0">Showing {{ perPage * (veridaTransactionTNcurrentPage-1) + 1 }} to {{ totalVeridaTNTransactionRows }} of {{ totalVeridaTNTransactionRows }} entries</span>-->
                  <span v-else>Showing 0 entries</span>
                </div>
                <div style="margin: 0 1rem; float: right;">
                  <b-pagination style="margin: .5rem 0;" align="center" :total-rows=totalVeridaTNTransactionRows v-model="veridaTransactionTNcurrentPage" :per-page=perPage :limit=limit @change="changeVeridaTransactionTNPage">
                  </b-pagination>
                </div>
              </div>
            </div>

            <div v-if="getUser()['is_admin'] || getUser()['is_superuser']" class="report-container">
              <div>
                <h4>Verida Problem Rides Report</h4>
              </div>
              <!--<button @click="download('problem', 'GEORGIA', 'verida')" class="btn btn-info waves-effect waves-light m-b-10" style="cursor: pointer;">Export</button>-->
              <button @click="showEmailConfirmModal = true; emailType = 'problem'; emailMarket = ''; emailProvider = ''" class="btn btn-info waves-effect waves-light m-b-10" style="cursor: pointer;">Email</button>
              <div class="" style="max-height: 300px; overflow-y: auto;">
                <form v-on:submit.prevent>
                  <table class="table table-sm table-hover" data-sort-name="Date">
                    <thead>
                    <tr>
                      <th class="result-label" v-for="column in data.problemItemizedColumns">
                        <div>
                          {{column}}
                          <div class="arrow-down" v-bind:id="column" style="visibility: hidden; margin-left: 5px;"></div>
                        </div>
                      </th>
                    </tr>
                    </thead>
                    <tbody class="col-12">
                    <tr class="ride-item text-xs-center" v-for="problemRide in data.veridaProblemRides" >
                      <td class="result-item" v-for="item in problemRide">
                        {{ item }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </form>
              </div>
              <div style="background-color: rgba(0, 0, 0, 0.05); float: left; width: 100%;">
                <div style="margin: 1rem 1rem; float: left;">
                  <span v-if="totalVeridaProblemRows != 1">Showing 1 to 100 of {{ totalVeridaProblemRows }} entries</span>
                  <span v-else>Showing 1 entry</span>
                </div>
              </div>
            </div>

            <div v-if="getUser()['is_admin'] || getUser()['is_superuser']" class="report-container">
              <div>
                <h4>Verida TN/VA Monthly Insurance Report</h4>
              </div>
              <!--<button @click="download('insurance', 'TENNESSEE', 'verida')" class="btn btn-info waves-effect waves-light m-b-10" style="cursor: pointer;">Export</button>-->

              <button @click="showEmailConfirmModal = true; emailType = 'insurance'; emailMarket = 'TENNESSEE'; emailProvider = ''" class="btn btn-info waves-effect waves-light m-b-10" style="cursor: pointer;">Email</button>
              <button @click="getVeridaInsuranceReport(true)" class="btn btn-info waves-effect waves-light m-b-10" style="cursor: pointer;">Upload to Y-Risk</button>
              <span v-if="data.yriskUploaded == true" class="label label-success m-l-10">Uploaded to Y-Risk</span>
              <span v-if="data.yriskUploaded == 'checking'" class="label label-warning m-l-10">Checking Y-Risk upload status...</span>
              <span v-if="data.yriskUploaded == false" class="label label-danger m-l-10">Not uploaded to Y-Risk</span>

              <div class="" style="max-height: 300px; overflow-y: auto;">
                <form v-on:submit.prevent>
                  <table class="table table-sm table-hover" data-sort-name="Date">
                    <thead>
                    <tr>
                      <th class="result-label" v-for="column in data.insuranceColumns">
                        <div>
                          {{column}}
                          <div class="arrow-down" v-bind:id="column" style="visibility: hidden; margin-left: 5px;"></div>
                        </div>
                      </th>
                    </tr>
                    </thead>
                    <tbody class="col-12">
                    <tr class="ride-item text-xs-center" v-for="insuranceRide in data.veridaInsuranceRides" >
                      <td class="result-item" v-for="item in insuranceRide">
                        {{ item }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </form>
              </div>
              <div style="background-color: rgba(0, 0, 0, 0.05); float: left; width: 100%;">
                <div style="margin: 1rem 1rem; float: left;">
                  <span v-if="totalVeridaInsuranceRows != 1">Showing {{ totalVeridaInsuranceRows }} entries</span>
                  <span v-else>Showing 1 entry</span>
                </div>
              </div>
            </div>

            <div v-if="getUser()['is_admin'] || getUser()['is_superuser']" class="report-container">
              <div>
                <h4>Wingz GA Itemized Report</h4>
              </div>
              <!--<button @click="download('itemized', 'GEORGIA', 'wingz')" class="btn btn-info waves-effect waves-light m-b-10" style="cursor: pointer;">Export</button>-->
              <button @click="showEmailConfirmModal = true; emailType = 'Itemized'; emailMarket = 'GEORGIA'; emailProvider = 'wingz'" class="btn btn-info waves-effect waves-light m-b-10" style="cursor: pointer;">Email</button>
              <div class="" style="max-height: 300px; overflow-y: auto;">
                <form v-on:submit.prevent>
                  <table class="table table-sm table-hover" data-sort-name="Date">
                    <thead>
                    <tr>
                      <th class="result-label" v-for="column in data.wingzItemizedColumns">
                        <div>
                          {{column}}
                          <div class="arrow-down" v-bind:id="column" style="visibility: hidden; margin-left: 5px;"></div>
                        </div>
                      </th>
                    </tr>
                    </thead>
                    <tbody class="col-12">
                    <tr class="ride-item text-xs-center" v-for="itemizedGAride in data.wingzGAitemized" >
                      <td class="result-item" v-for="item in itemizedGAride">
                        {{ item }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </form>
              </div>
              <div style="background-color: rgba(0, 0, 0, 0.05); float: left; width: 100%;">
                <div style="margin: 1rem 1rem; float: left;">
                  <span v-if="totalWingzItemizedGArows > 0">Showing {{ perPage * (itemizedGAcurrentPage-1) + 1 }} to {{ perPage * itemizedGAcurrentPage > totalWingzItemizedGArows ? totalWingzItemizedGArows : perPage * itemizedGAcurrentPage }} of {{ totalWingzItemizedGArows }} entries</span>
                  <span v-else>Showing 0 entries</span>
                </div>
                <div style="margin: 0 1rem; float: right;">
                  <b-pagination style="margin: .5rem 0;" align="center" :total-rows=totalWingzItemizedGArows v-model="itemizedGAcurrentPage" :per-page=perPage :limit=limit @change="changeWingzItemizedGAPage">
                  </b-pagination>
                </div>
              </div>
            </div>


            <div class="report-container">
              <div>
                <h4>Deadhead Mileage Report</h4>
              </div>
              <div>
                <div class="col-md-3 col-lg-3 p-0" style="float: left;">
                  <div class="m-3 form-ddown">
                    <label class="search-label">Beginning Date</label>
                    <datetime type="datetime" v-model="deadhead_mileage_start" input-class="form-control form-control-sm" placeholder="Min Pickup Date" label="Min Pickup Date" :noClearButton="false">
                    </datetime>
                  </div>
                </div>
                <div class="col-md-3 col-lg-3 p-0" style="float: left;">
                  <div class="m-3 form-ddown">
                    <label class="search-label">Maximum Date</label>
                    <datetime type="datetime"  v-model="deadhead_mileage_end" label="Max Pickup Date" input-class="form-control form-control-sm" placeholder="Max Pickup Date" >
                    </datetime>
                  </div>
                </div>
                <div style="float: left; padding: 40px;">
                  <a target="_blank" :href="deadhead_mileage_url + '?start_date=' + (deadhead_mileage_start ? moment(deadhead_mileage_start).format('YYYY-MM-DDTHH:mm:ss') + '.000Z' : '') + '&end_date=' + (deadhead_mileage_end ? moment(deadhead_mileage_end).format('YYYY-MM-DDTHH:mm:ss') + '.000Z' : '')" class="btn btn-info waves-effect waves-light m-b-10" style="cursor: pointer;">Download</a>
                </div>
              </div>
            </div>
            <br>
            <br>
            <div class="report-container">
              <div>
                <h4>Bad Geocode Report</h4>
              </div>
              <div>
                <div class="col-md-3 col-lg-3 p-0" style="float: left;">
                  <div class="m-3 form-ddown">
                    <label class="search-label">Beginning Date</label>
                    <datetime type="datetime" v-model="bad_geocode_start" input-class="form-control form-control-sm" placeholder="Min Detection Date" label="Min Detection Date" :noClearButton="false">
                    </datetime>
                  </div>
                </div>
                <div class="col-md-3 col-lg-3 p-0" style="float: left;">
                  <div class="m-3 form-ddown">
                    <label class="search-label">Maximum Date</label>
                    <datetime type="datetime"  v-model="bad_geocode_end" label="Max Detection Date" input-class="form-control form-control-sm" placeholder="Max Detection Date" >
                    </datetime>
                  </div>
                </div>
                <div style="float: left; padding: 40px;">
                  <a target="_blank" :href="bad_geocode_url + '?start_date=' + (bad_geocode_start ? moment(bad_geocode_start).format('YYYY-MM-DDTHH:mm:ss') + '.000Z' : '') + '&end_date=' + (bad_geocode_end ? moment(bad_geocode_end).format('YYYY-MM-DDTHH:mm:ss') + '.000Z' : '')" class="btn btn-info waves-effect waves-light m-b-10" style="cursor: pointer;">Download</a>
                </div>
              </div>
            </div>

            <br>
            <br>
            <div v-if="getUser()['is_admin'] || getUser()['is_superuser']" class="report-container" style="display: block !important;">
              <div>
                <h4>P2/P3 Mileage Lookup</h4>
              </div>
              <div>
                <div class="col-md-3 col-lg-3 p-0" style="float: left;">
                  <div class="m-3 form-ddown">
                    <label class="search-label">Driver ID</label>
                    <input v-model="p2p3_id_driver" class="form-control form-control-sm" placeholder="Driver ID" :noClearButton="false">
                    </input>
                  </div>
                </div>
                <div class="col-md-3 col-lg-3 p-0" style="float: left;">
                  <div class="m-3 form-ddown">
                    <label class="search-label">Year</label>
                    <input v-model="p2p3_year" class="form-control form-control-sm">
                    </input>
                  </div>
                </div>
                <div style="float: left; padding: 40px;">
                  <a target="_blank" @click="getP2P3()" class="btn btn-info waves-effect waves-light m-b-10" style="cursor: pointer; color: white">Generate</a>
                </div>


                <div style="float: left; padding: 40px;">
                  <a target="_blank" @click="getP2P3(true)" class="btn btn-info waves-effect waves-light m-b-10" style="cursor: pointer; color: white">Generate for all drivers</a>
                </div>
              </div>

              <br>
              <br>
              <br>
              <br>
              <br>
              <div v-if="p2p3_data" style="display: block; padding-left: 1rem;">
                <table class="table table-sm table-hover">
                  <thead>
                      <tr class="result-label">
                        <td>Driver ID</td>
                        <td>Driver Name</td>
                        <td>P2 Mileage</td>
                        <td>P3 Mileage</td>
                        <td>Ride Count</td>
                        <td>Year</td>
                      </tr>
                  </thead>
                  <tbody>
                  <tr class="ride-item text-xs-center" v-for="row in p2p3_data">
                    <td>{{row['id_driver']}}</td>
                    <td>{{row['driver_name']}}</td>
                    <td>{{row['p2']}}</td>
                    <td>{{row['p3']}}</td>
                    <td>{{row['ride_count']}}</td>
                    <td>{{row['year']}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Ride distribution confirmation modal -->
    <div>
      <div>
        <!-- use the modal component, pass in the prop -->
        <modal v-if="showEmailConfirmModal" @close="showEmailConfirmModal = false">
          <h3 slot="header">
            Email {{ this.emailType }} Report
          </h3>
          <div slot="body">
            <div>
              Please enter the recipient email:
            </div>
            <div style="height: 20px"/>
            <input v-model="recipientEmail" class="form-control form-control-sm" placeholder="Email" style="width:100%" type="text">
          </div>
          <div slot="footer" >
            <button class="modal-default-button btn btn-info waves-effect waves-light m-t-10" @click="emailReport()">
              Submit
            </button>
            <button class="modal-default-button btn btn-default m-t-10" @click="showEmailConfirmModal = false">
              Cancel
            </button>
          </div>
        </modal>
      </div>
    </div>

    <!-- Email success confirmation modal -->
    <div>
      <div>
        <!-- use the modal component, pass in the prop -->
        <modal v-if="showEmailSuccessModal" @close="showEmailSuccessModal = false">
          <h3 slot="header">
            Email {{ this.emailType }} Report
          </h3>
          <div slot="body">
            <div>
              The request to send the email has been received. The email should be received in the next few minutes.
            </div>
          </div>
          <div slot="footer" >
            <button class="modal-default-button btn btn-default m-t-10" @click="showEmailSuccessModal = false">
              Ok
            </button>
          </div>
        </modal>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  // Import component
  import Loading from 'vue-loading-overlay'
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css'

  // register modal component
  Vue.component('modal', {
    template: '#modal-template'
  })

  export default {
    metaInfo: {
      title: 'Wingz Support | Reports', // set a title
    },
    data () {
      return {
        title: 'Reports',
        isLoading: false,
        errors: null,
        totalWeeklyGARows: 0,
        totalWeeklyTNRows: 0,
        totalBookingGArows: 0,
        totalBookingTNrows: 0,
        totalWingzItemizedGArows: 0,
        totalVeridaItemizedGArows: 0,
        totalVeridaItemizedTNrows: 0,
        totalVeridaGATransactionRows: 0,
        totalVeridaTNTransactionRows: 0,
        totalVeridaProblemRows: 0,
        totalVeridaInsuranceRows: 0,
        perPage: 20,
        limit: 10,
        currentPage: 1,
        bookingGAcurrentPage: 1,
        bookingTNcurrentPage: 1,
        itemizedGAcurrentPage: 1,
        veridaItemizedGAcurrentPage: 1,
        veridaItemizedTNcurrentPage: 1,
        veridaTransactionGAcurrentPage: 1,
        veridaTransactionTNcurrentPage: 1,
        toastPosition: 'bottom-center',
        showEmailConfirmModal: false,
        showEmailSuccessModal: false,
        recipientEmail: null,
        emailType: null,
        emailMarket: null,
        emailProvider: 'verida',
        weeks: null,
        months: null,
        selected_ga_week: 1,
        selected_tn_week: 1,
        selected_month: 1,
        deadhead_mileage_start: null,
        deadhead_mileage_end: null,
        deadhead_mileage_url: process.env.API_BASE_URL + 'reports/deadhead_mileage',

        bad_geocode_start: null,
        bad_geocode_end: null,
        bad_geocode_url: process.env.API_BASE_URL + 'reports/bad_geocode',

        p2p3_id_driver: null,
        p2p3_year: 2020,
        p2p3_data: null,
        data: {
          weeklyColumns: [],
          wingzItemizedColumns: [],
          veridaItemizedColumns: [],
          transactionItemizedColumns: [],
          problemItemizedColumns: [],
          insuranceColumns: [],
          sortDirection: 0,
          weeklyGArides: [],
          weeklyTNrides: [],
          veridaGAbooking: [],
          veridaTNbooking: [],
          wingzGAitemized: [],
          veridaGAitemized: [],
          veridaTNitemized: [],
          veridaGATransaction: [],
          veridaTNTransaction: [],
          veridaProblemRides: [],
          veridaInsuranceRides: [],
          yriskUploaded: 'checking',
        },
      }
    },
    components: {
      Loading
    },watch: {
      deadhead_mileage_start: function(deadhead_mileage_start) {
        console.log((deadhead_mileage_start ? this.moment(deadhead_mileage_start).format('YYYY-MM-DDTHH:mm:ss') + '.000Z' : ''))
      },
      deadhead_mileage_end: function(deadhead_mileage_end) {
        console.log((deadhead_mileage_end ? this.moment(deadhead_mileage_end).format('YYYY-MM-DDTHH:mm:ss') + '.000Z' : ''))
      },
      bad_geocode_start: function(bad_geocode_start) {
        console.log((bad_geocode_start ? this.moment(bad_geocode_start).format('YYYY-MM-DDTHH:mm:ss') + '.000Z' : ''))
      },
      bad_geocode_end: function(bad_geocode_end) {
        console.log((bad_geocode_end ? this.moment(bad_geocode_end).format('YYYY-MM-DDTHH:mm:ss') + '.000Z' : ''))
      }
    },
    methods: {
      changePage: function (page) {
        console.log('change to page: ' + page)
        console.log('bookingGAcurrentPage: ' + this.bookingGAcurrentPage)
      },
      changeBookingGAPage: function (page) {
        console.log('change booking GA to page: ' + page)
        this.bookingGAcurrentPage = page
        // this.getVeridaBookingReport("GEORGIA")
      },
      changeBookingTNPage: function (page) {
        console.log('change booking TN to page: ' + page)
        this.bookingTNcurrentPage = page
        // this.getVeridaBookingReport("TENNESSEE")
      },
      changeWingzItemizedGAPage: function (page) {
        console.log('change Wingz itemized GA to page: ' + page)
        this.itemizedGAcurrentPage = page
        this.getWingzItemizedReport("wingz", "GEORGIA")
      },
      changeVeridaItemizedGAPage: function (page) {
        console.log('change Verida itemized GA to page: ' + page)
        this.veridaItemizedGAcurrentPage = page
        this.getWingzItemizedReport("verida", "GEORGIA")
      },
      changeVeridaItemizedTNPage: function (page) {
        console.log('change Verida itemized TN to page: ' + page)
        this.veridaItemizedTNcurrentPage = page
        this.getWingzItemizedReport("verida", "TENNESSEE")
      },
      changeVeridaTransactionGAPage: function (page) {
        console.log('change Verida transaction GA to page: ' + page)
        this.veridaTransactionGAcurrentPage = page
        this.getWingzItemizedReport("verida", "GEORGIA", "transaction")
      },
      changeVeridaTransactionTNPage: function (page) {
        console.log('change Verida transaction TN to page: ' + page)
        this.veridaTransactionTNcurrentPage = page
        this.getWingzItemizedReport("verida", "TENNESSEE", "transaction")
      },
      resetPager: function () {
        this.currentPage = 1
        this.totalRows = 0
      },
      getVeridaWeeklyReport(market) {
        console.log('selected weeks: ', this.selected_ga_week, this.selected_tn_week)
        this.isLoading = true
        var params = {"market": market}
        if (market == "GEORGIA") {
          params['start'] = this.weeks[this.selected_ga_week]['monday']
          params['end'] = this.weeks[this.selected_ga_week]['sunday']
        }
        else if (market == "TENNESSEE") {
          params['start'] = this.weeks[this.selected_tn_week]['monday']
          params['end'] = this.weeks[this.selected_tn_week]['sunday']
        }
        this.$http
          .post(process.env.API_BASE_URL + 'reports/weekly/', params)
          .then(response => {
            console.log("Verida Weekly Response for ", market, ":", response.data.results.length, response.data.results)
            if (market == "GEORGIA") {
              this.data.weeklyColumns = response.data.columns
              this.data.weeklyGArides = response.data.results
              this.totalWeeklyGARows = response.data.count
            }
            else if (market == "TENNESSEE") {
              this.data.weeklyColumns = response.data.columns
              this.data.weeklyTNrides = response.data.results
              this.totalWeeklyTNRows = response.data.count
            }
          })
          .catch(error => {
            console.log("Error response: ", error)
            this.errors = error
            this.non_field_errors = error
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      getVeridaBookingReport(market) {
        this.isLoading = true
        var offset = 0
        if (market == "GEORGIA") {
          offset = (this.bookingGAcurrentPage-1)*20
        }
        else if (market == "TENNESSEE") {
          offset = (this.bookingTNcurrentPage-1)*20
        }
        var params = {"market": market, "offset": offset}
        this.$http
          .post(process.env.API_BASE_URL + 'reports/booking/', params)
          .then(response => {
            console.log("Verida ", market, " Booking Response: ", response.data)
            if (market == "GEORGIA") {
              this.data.veridaGAbooking = response.data.results
              this.totalBookingGArows = response.data.count
            }
            else if (market == "TENNESSEE") {
              this.data.veridaTNbooking = response.data.results
              this.totalBookingTNrows = response.data.count
            }
          })
          .catch(error => {
            console.log("Error response: ", error)
            this.errors = error
            this.non_field_errors = error
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      getWingzItemizedReport(provider, market, reportType=null, limit=null, offset=null) {
        console.log("Retrieving itemized report for " + provider + " " + market + " " + reportType)
        this.isLoading = true
        if (offset == null) {
          if (provider == "wingz") {
            offset = (this.itemizedGAcurrentPage-1)*20
          } else if (provider == "verida" && market == "GEORGIA" && reportType == "transaction") {
            offset = (this.veridaTransactionGAcurrentPage-1)*20
          } else if (provider == "verida" && market == "TENNESSEE" && reportType == "transaction") {
            offset = (this.veridaTransactionTNcurrentPage-1)*20
          } else if (provider == "verida" && market == "GEORGIA") {
            offset = (this.veridaItemizedGAcurrentPage-1)*20
          } else if (provider == "verida" && market == "TENNESSEE") {
            offset = (this.veridaItemizedTNcurrentPage-1)*20
          }
        }
        var params = {"offset": offset, "market": market, "start": this.months[this.selected_month-1]['first'], "end": this.months[this.selected_month-1]['last']}
        if (reportType != null) {
          params['type'] = reportType
        }
        if (limit != null) {
          params['limit'] = limit
        }
        // console.log('Itemized report params: ', params)
        this.$http
          .post(process.env.API_BASE_URL + 'reports/itemized/?provider=' + provider, params)
          .then(response => {
            if (limit == null) {
              console.log(provider + " " + market + " " + reportType + " Response: ", response.data)
              if (provider == "wingz") {
                this.data.wingzItemizedColumns = response.data.columns
                this.data.wingzGAitemized = response.data.results
                this.totalWingzItemizedGArows = response.data.count
              }
              else if (provider == "verida") {
                if (reportType == null) {
                  if (market == "GEORGIA") {
                    this.data.veridaItemizedColumns = response.data.columns
                    this.data.veridaGAitemized = response.data.results
                    this.totalVeridaItemizedGArows = response.data.count
                  }
                  else if (market == "TENNESSEE") {
                    this.data.veridaItemizedColumns = response.data.columns
                    this.data.veridaTNitemized = response.data.results
                    this.totalVeridaItemizedTNrows = response.data.count
                  }
                }
                else {
                  if (reportType == "problem") {
                    this.data.problemItemizedColumns = response.data.columns
                    this.data.veridaProblemRides = response.data.results.length > 100 ? response.data.results.slice(0, 100) : response.data.results
                    this.totalVeridaProblemRows = response.data.count
                  }
                  else if (reportType == "transaction") {
                    if (market == "GEORGIA") {
                      this.data.transactionItemizedColumns = response.data.columns
                      this.data.veridaGATransaction = response.data.results
                      this.totalVeridaGATransactionRows = response.data.count
                    }
                    else if (market == "TENNESSEE") {
                      this.data.transactionItemizedColumns = response.data.columns
                      this.data.veridaTNTransaction = response.data.results
                      this.totalVeridaTNTransactionRows = response.data.count
                    }
                  }
                }
              }
            }
          })
          .catch(error => {
            console.log("Error response: ", error)
            this.errors = error
            this.non_field_errors = error
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      getVeridaInsuranceReport(uploadToYrisk) {
        this.data.yriskUploaded = 'checking'
        this.isLoading = true
        var params = {}
        params["start"] = this.months[this.selected_month-1]['first']
        params["end"] = this.months[this.selected_month-1]['last']
        this.$http
          .post(process.env.API_BASE_URL + 'reports/insurance/?type=yrisk' + (uploadToYrisk ? '&upload_to_yrisk=1' : ''), params)
          .then(response => {
            console.log("Verida Insurance Response: ", response.data)
            this.data.insuranceColumns = response.data.columns
            this.data.veridaInsuranceRides = response.data.results
            this.data.yriskUploaded = response.data.yrisk_uploaded
            this.totalVeridaInsuranceRows = response.data.count
          })
          .catch(error => {
            console.log("Error response: ", error)
            this.errors = error
            this.non_field_errors = error
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      getP2P3(all=false) {
        if (!this.p2p3_id_driver && !all) {
          alert('Please input a driver ID')
          return
        }

        if (!this.p2p3_year || [2019, 2020, 2021, 2022, 2023, 2024, 2025].indexOf(parseInt(this.p2p3_year)) < 0) {
          alert('Please input a valid year')
          return
        }
        this.p2p3_data = null;
        this.isLoading = true
        let url = process.env.API_BASE_URL + 'reports/p2p3/?id_driver=' + this.p2p3_id_driver + '&year=' + this.p2p3_year
        if (all) {
          url = process.env.API_BASE_URL + 'reports/p2p3/?year=' + this.p2p3_year
        }
        var params = {}
        // params["start"] = this.months[this.selected_month-1]['first']
        // params["end"] = this.months[this.selected_month-1]['last']
        this.$http
          .get(url, params)
          .then(response => {
            console.log("Verida Insurance Response: ", response.data)
            this.p2p3_data = response.data
          })
          .catch(error => {
            console.log("Error response: ", error)
            this.errors = error
            this.non_field_errors = error
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      download: function(type, market, provider=null) {
        if (type != null && market != null) {
          this.isLoading = true
          console.log('downloading: ', type, ' for ', market)
          if (type == 'booking') {
            type = "download_booking_report"
          }
          else if (type == 'weekly') {
            type = "download_weekly_report"
          }
          else if (type == 'itemized') {
            type = "download_itemized_report"
          }
          else if (type == 'transaction') {
            type = "download_transaction_report"
          }
          else if (type == 'problem') {
            type = "download_problem_report"
          }
          else if (type == 'insurance') {
            type = "download_insurance_report"
          }
          else {
            this.showToastError('Unable to recognize export link')
          }
          var params = {"market": market, "limit": 0, "provider": provider}
          if (market == "GEORGIA") {
            params['start'] = this.weeks[this.selected_ga_week]['monday']
            params['end'] = this.weeks[this.selected_ga_week]['sunday']
          }
          else if (market == "TENNESSEE") {
            params['start'] = this.weeks[this.selected_tn_week]['monday']
            params['end'] = this.weeks[this.selected_tn_week]['sunday']
          }
          console.log(type, ' download params: ', params)
          this.$http({
            url: process.env.API_BASE_URL + 'reports/' + type + '/',
            method: 'GET',
            params: params,
            body: params,
            responseType: 'blob', // important
          }).then((response) => {
            console.log('download response: ', response.data.results)
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            var fileName = type + (type != 'download_problem_report' ? '-' + market : '') + '.csv'
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            this.isLoading = false
          }).catch(error => {
            console.log("Error response: ", error)
            this.errors = error
            this.non_field_errors = error
          }).finally(() => {
            this.isLoading = false
          });
        }
      },
      emailReport() {
        if (this.recipientEmail == null) {
          Vue.toasted.show('Please enter a valid email address', {
            theme: 'bubble',
            position: this.toastPosition,
            duration: 2000
          })
          return false
        }
        var params = {
          "type": this.emailType,
          "market": this.emailMarket,
          "email": this.recipientEmail,
          "provider": this.emailProvider
        }

        if (this.emailType == "transaction" || this.emailType == "insurance") {
          params["start"] = this.months[this.selected_month-1]['first']
          params["end"] = this.months[this.selected_month-1]['last']
        }
        else if (this.emailMarket == "GEORGIA") {
          params['start'] = this.weeks[this.selected_ga_week]['monday']
          params['end'] = this.weeks[this.selected_ga_week]['sunday']
        }
        else if (this.emailMarket == "TENNESSEE") {
          params['start'] = this.weeks[this.selected_tn_week]['monday']
          params['end'] = this.weeks[this.selected_tn_week]['sunday']
        }
        console.log('emailing params: ', params)
        this.showEmailConfirmModal = false
        this.isLoading = true
        this.$http
          .post(process.env.API_BASE_URL + 'reports/email_report/', params)
          .then(response => {
            console.log('Email response: ', response)
            this.showEmailSuccessModal = true
          })
          .catch(error => {
            console.log("Error response: ", error)
            this.errors = error
            this.non_field_errors = error
          })
          .finally(() => {
            this.isLoading = false
            this.recipientEmail = null
          })
      },
      getReports: function() {
        this.getWingzItemizedReport("wingz", "GEORGIA")
        this.getWingzItemizedReport("verida", "GEORGIA", "problem")
        var markets = ["GEORGIA", "TENNESSEE"]
        for (var market in markets) {
          this.getWingzItemizedReport("verida", markets[market], "transaction")
        }
        this.getVeridaInsuranceReport()
      },
      getWeeks: function () {
        this.$http
          .get(process.env.API_BASE_URL_CS + 'transactions/weeks/?start=0')
          .then(response => {
            console.log('Weeks response: ', response)
            console.log(response.data)
            this.weeks = response.data
            this.selected_ga_week = this.weeks[0].week
            this.selected_tn_week = this.weeks[0].week
            for (let index in this.weeks) {
              this.weeks[index].monday = this.moment(this.weeks[index].monday).tz('Europe/Lisbon').format("YYYY-MM-DD")
              this.weeks[index].sunday = this.moment(this.weeks[index].sunday).tz('Europe/Lisbon').format("YYYY-MM-DD")
              this.weeks[index].processed_date = this.moment(this.weeks[index].processed_date).tz('Europe/Lisbon').format("YYYY-MM-DD")
              this.weeks[index].payment_received = this.moment(this.weeks[index].payment_received).tz('Europe/Lisbon').format("YYYY-MM-DD")
            }
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
            this.isLoading = false
          })
          .finally(() => {
            this.getReports()
          })
      },
      getMonths: function () {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS + 'transactions/months/')
          .then(response => {
            console.log('Months response: ', response)
            console.log(response.data)
            this.months = response.data
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
            this.isLoading = false
          })
          .finally(() => {
            this.getWeeks()
          })
      },
    },
    mounted(){
      if (this.getUser()['is_admin'] || this.getUser()['is_superuser']) {
        this.getMonths()
      }
    },
  }
</script>

<style scoped>
.report-container {
  margin-bottom: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/Reports.vue